import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
//grid
import { AgGridNg2 } from 'ag-grid-angular';

import { Correo } from '../Models/Correo';

import { CorreoService } from '../services/correo.service';
import { UtilesService } from '../services/utiles.service';
import { GlobalsService } from '../services/globals.service';
import { CorreoClienteLayoutComponent } from '../correo-cliente-layout/correo-cliente-layout.component';

@Component({
  selector: 'app-correo',
  templateUrl: './correo.component.html',
  styleUrls: ['./correo.component.css']
})
export class CorreoComponent implements OnInit {

  public correo: Correo = new Correo();
  public correos: Correo[];

  public grupoCorreos: Correo[];
  public grupoCorreo: Correo = new Correo();

  public modoEdicion: boolean = false;

  public codigoGrupo: string;

  //grid
  @ViewChild('agGrid') agGrid: AgGridNg2;

  title = 'Correos';

  columnDefs = [
    //  {headerName: 'Identificador', field: 'idRuta' },
    { headerName: 'Código Grupo', field: 'idCodigoGrupo', icons: { filter: ' ' } },
    { headerName: 'Email', field: 'email', icons: { filter: ' ' } },

  ];

  rowData: any[];

  constructor(
    private correoService: CorreoService,
    private globalServices: GlobalsService) {

  }

  ngOnInit() {

    this.CargarGrupos();
  }




  CargarGrupos() {

    try {

      this.correoService.ObtenerGrupoCorreo().subscribe(
        data => {
          this.grupoCorreos = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarGrupos: " + error);
    }
  }

  GrupoSeleccionado() {
    try {

      this.CargarCorreos();

    } catch (error) {
      console.log("GrupoSeleccionado: " + error);
    }
  }

  CargarCorreos() {
    try {
      var codigo=this.grupoCorreo.idCodigoGrupo;
      this.correoService.ObtenerCorrerosGrupo(this.globalServices.ObtenerCompania(), this.grupoCorreo.idCodigoGrupo).subscribe(
        data => {
          this.correos = data;
          this.rowData = this.correos;
        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarRutas:" + error);
    }
  }

  NuevoRegistro() {
   this.correo = new Correo();
    this.modoEdicion = true;

  }

  CancelarEdicion() {

    this.correo = new Correo();
    this.modoEdicion = false;
  }


  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));
    this.correo=datos;
    this.modoEdicion = true;

  }

  GuardarRegistro() {

    this.correo.idCompania = this.globalServices.ObtenerCompania();
    this.correo.idCodigoGrupo=this.grupoCorreo.idCodigoGrupo;
    
    if (this.correo.idCorreo === undefined) {
      this.correo.idCorreo = UUID.UUID();
    }

    this.correoService.GuardarRegistro(this.correo).subscribe(
      data => {

        swal("Registro guardado con éxito!", "", "success");

        this.correo = new Correo();
        this.modoEdicion = false;
      },
      err => {
        console.error(err);
        swal("Hubo un error a la hora de la ejecución", "", "error");
      }

    );



  }
}
